module.exports = __webpack_public_path__ + "media/37.bcea7ad6.mp3";